import { FC, MouseEvent, MouseEventHandler, ReactNode } from 'react'
import useMouseOverOut from '@hooks/useMouseOverOut'
import Loader from '@molecules/Loader'
import Badge from '@molecules/Badge'
import Prompt from '@molecules/Prompt'
import { BigTabRow, BigTitleText, Counter, SmallInnerWrapper, SmallWrapper, Text } from './styled'

type Props = {
  children?: ReactNode
  isActive?: boolean
  onClick?: MouseEventHandler
  title: string | number
  tabSize: 'big' | 'small'
  badgeColor?: string
  withStopPropagation?: boolean
  isLoading?: boolean
  withoutHover?: boolean
  id: string
  isWhiteBackground?: boolean
  promptText?: string
  counter?: number
}

const Tab: FC<Props> = ({
  isActive,
  onClick,
  title,
  tabSize,
  badgeColor,
  withStopPropagation = false,
  isLoading = false,
  withoutHover = false,
  id,
  isWhiteBackground = false,
  promptText,
  counter,
}) => {
  const [hovered, , handleMouseEnter, handleMouseLeave] = useMouseOverOut()
  const active = isActive || hovered

  if (tabSize === 'small') {
    return (
      <div key={id}>
        <SmallWrapper
          id={id}
          onClick={(e) => {
            if (withStopPropagation) {
              e.stopPropagation()
            }
            onClick?.(e)
          }}
          selected={active}
          onMouseEnter={withoutHover ? undefined : handleMouseEnter}
          onMouseLeave={withoutHover ? undefined : handleMouseLeave}
          isWhiteBackground={isWhiteBackground}
          withoutHover={withoutHover}
        >
          <Loader isLoading={isLoading}>
            <SmallInnerWrapper>
              {badgeColor && <Badge badgeColor={badgeColor} />}
              <Text selected={active} isWhiteBackground={isWhiteBackground}>
                {title}
              </Text>
              {promptText && <Prompt promptText={promptText} width={300} />}
              {counter != null && counter >= 0 && (
                <Counter isActive={active}>{counter}</Counter>
              )}
            </SmallInnerWrapper>
          </Loader>
        </SmallWrapper>
      </div>
    )
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      id={id}
    >
      <BigTabRow
        isActive={active}
        onClick={(e: MouseEvent) => {
          e.stopPropagation()
          onClick?.(e)
        }}
      >
        <Loader isLoading={isLoading}>
          <BigTitleText>{title}</BigTitleText>
        </Loader>
        {counter != null && counter >= 0 && (
          <Counter isActive={active}>{counter}</Counter>
        )}
      </BigTabRow>
    </div>
  )
}

export type { Props as TabProps }
export default Tab
